import React from 'react';
import Img from 'gatsby-image';
import { v4 as uuidv4 } from 'uuid';
// import styled from 'styled-components';

function Image({ image, pageData, refProps }) {
  return (
    <Img
      ref={refProps}
      fluid={image.asset.fluid}
      style={
        pageData.images && image === pageData.images[pageData.images.length - 1]
          ? { marginBottom: '0' }
          : { marginBottom: '1rem' }
      }
    />
  );
}

export default function ImagesBlock({ pageData, refProps, setIsBig, isBig }) {
  const dataImages = () => {
    if (pageData.realisation) {
      return pageData.realisation;
    }
    if (pageData.etude) {
      return pageData.etude;
    }
    if (pageData.actu) {
      return pageData.actu;
    }
    if (pageData.queryPage) {
      return pageData.queryPage.nodes[0];
    }
    return pageData;
  };

  const handleKeyUp = () => {};
  return (
    <>
      {dataImages().images && dataImages().images[0] && (
        <div
          className="imageBox"
          onClick={() => setIsBig(!isBig)}
          onKeyUp={handleKeyUp}
          role="button"
          tabIndex="0"
        >
          {dataImages().images &&
            dataImages().images.map(
              (image) =>
                image.asset && (
                  <Image
                    refProps={refProps}
                    image={image}
                    pageData={dataImages()}
                    key={uuidv4()}
                  />
                )
            )}

          {dataImages().photo && (
            <Image
              refProps={refProps}
              image={dataImages().photo}
              pageData={dataImages()}
              key={uuidv4()}
            />
          )}
        </div>
      )}
    </>
  );
}
